import React, { useState } from "react";
import styles from "./Platform.module.scss";

function Platform() {
  const [activeModel, setActiveModel] = useState<'b2c' | 'd2c'>('b2c');
  const platformComparison = {
    b2c: {
      title: "B2C Marketplace Platform",
      subtitle: "Multi-vendor marketplace solution",
      keyFunctions: [
        {
          title: "Vendor Ecosystem Management",
          features: [
            "Automated vendor onboarding with KYC verification",
            "Commission structure configuration and management",
            "Vendor performance scoring and ranking",
            "Bulk vendor communication tools",
          ],
        },
        {
          title: "Marketplace Operations",
          features: [
            "Centralized product catalog with approval workflows",
            "Dynamic pricing and promotion management",
            "Cross-vendor inventory synchronization",
            "Dispute resolution and mediation system",
          ],
        },
        {
          title: "Revenue Management",
          features: [
            "Automated commission calculation and distribution",
            "Multi-tier pricing and fee structures",
            "Revenue sharing analytics and reporting",
            "Tax calculation and compliance management",
          ],
        },
      ],
    },
    d2c: {
      title: "D2C Brand Platform",
      subtitle: "Direct-to-consumer brand solution",
      keyFunctions: [
        {
          title: "Brand Experience Control",
          features: [
            "Fully customizable storefront design",
            "Brand-specific checkout and user journey",
            "Custom domain and SSL management",
            "Brand asset management and consistency",
          ],
        },
        {
          title: "Customer Data Ownership",
          features: [
            "Complete customer data control and privacy",
            "First-party data collection and analysis",
            "Custom customer segmentation",
            "Direct customer communication channels",
          ],
        },
        {
          title: "Marketing Automation",
          features: [
            "Email marketing and automation workflows",
            "Social media integration and management",
            "Influencer collaboration tools",
            "Content management and SEO optimization",
          ],
        },
      ],
    },
  };
  return (
    <section className={styles["platform-section"]}>
      <div className={styles["platform-container"]}>
        <div className={styles["platform-header"]}>
          <h2 className="heading">Platform-Specific Functionalities</h2>
          <p className="subHeading">
            Specialized features tailored for B2C marketplaces and D2C brand platforms
          </p>
    
          <div className={styles["platform-toggle"]}>
            {Object.entries(platformComparison).map(([key, platform]) => (
              <button
                key={key}
                onClick={() => setActiveModel(key as "b2c" | "d2c")}
                className={`${styles["toggle-btn"]} ${
                  activeModel === key ? styles["active"] : ""
                }`}
              >
                {platform.title}
              </button>
            ))}
          </div>
        </div>
    
        <div className={styles["platform-card"]}>
          <div className={styles["platform-card-header"]}>
            <h3 className="heading">{platformComparison[activeModel].title}</h3>
            <p className="subHeading">{platformComparison[activeModel].subtitle}</p>
          </div>
    
          <div className={styles["platform-grid"]}>
            {platformComparison[activeModel].keyFunctions.map((func, index) => (
              <div key={index} className={styles["function-card"]}>
                <h4>{func.title}</h4>
                <div className={styles["function-list"]}>
                  {func.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className={styles["function-item"]}>
                      <div className={styles["dot"]} />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    
  );
}

export default Platform;
